module.exports = __webpack_public_path__ + "img/1.17fbd8c0.png";